<!-- Spinner while catalog is being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading the user list. Click below try again.
    <button hc-button size="lg" (click)="loadUsers()">Reload Users</button>
</div>

<div class="admin-users-table-container" [hidden]="loadError || loading">
    <h2> <hc-icon fontSet="fa" fontIcon="fa-user"></hc-icon> Users </h2>
    <div class="admin-users-table-action-bar">
        <button hc-button (click)="openAddEditModal(addEditUserModal, false)">Add User</button>
        <hc-search-bar
        #searchbar
        placeholder="Search users"
        (triggerSearch)="applyFilter($event)"
        class="admin-users-search"
    ></hc-search-bar>
    </div>
    <table hc-table [borders]="false" class="admin-user-table" [dataSource]="dataSource" hcSort>
        <!-- Name Column -->
        <ng-container hcColumnDef="name">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Name</th>
            <td hc-cell *hcCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <!-- Okta ID Column -->
        <ng-container hcColumnDef="okta_id">
            <th hc-header-cell *hcHeaderCellDef id="oktaIDHeader">Okta ID</th>
            <td hc-cell *hcCellDef="let element">{{ element.okta_id }}</td>
        </ng-container>

        <!-- Okta ID Column -->
        <ng-container hcColumnDef="role">
            <th hc-header-cell *hcHeaderCellDef id="roleHeader">Role</th>
            <td hc-cell *hcCellDef="let element">{{ displayRole(element.role) }}</td>
        </ng-container>

        <!-- Icon Actions Column -->
        <ng-container hcColumnDef="actions" justify="center">
            <th hc-header-cell *hcHeaderCellDef id="actionsHeader"></th>
            <td hc-cell *hcCellDef="let element">
                <div class="hc-table-actions">
                    <span
                        hcMenuIcon
                        class="fa fa-trash hc-action-ico"
                        hcTooltip="Remove user"
                        (click)="removeUser(element)"
                    ></span>
                    <span
                        hcMenuIcon
                        class="fa fa-pencil hc-action-ico"
                        hcTooltip="Edit user"
                        (click)="openAddEditModal(addEditUserModal, true, element)"
                    ></span>
                </div>
            </td>
        </ng-container>

        <tr hc-header-row *hcHeaderRowDef="adminUsersDisplayedColumns"></tr>
        <tr hc-row *hcRowDef="let row; columns: adminUsersDisplayedColumns"></tr>
    </table>


    <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
        <span class="hc-empty-table-block-ico hc-empty-ico"></span>
        <span class="hc-empty-table-block-msg">No users meet your search criteria.</span>
    </div>

    <hc-pagination
        [length]="adminUsersListLength"
        [pageSize]="adminUsersPageSize"
        [pageSizeOptions]="adminUsersPageSizeOptions"
        [hidden]="loadError || loading"
    ></hc-pagination>
</div>

<ng-template #addEditUserModal let-dismiss="dismiss" let-data="data">
    <hc-modal>
        <hc-modal-header>{{ data.edit ? 'Edit' : 'Add' }} User</hc-modal-header>
        <hc-modal-body>
            <form [formGroup]="adminUserControl" class="admin-user-form">
                <hc-form-field>
                    <hc-label>Name:</hc-label>
                    <input hcInput formControlName="name" placeholder="Enter user's name" class="user-name-input" [required]="true" />
                    <hc-error>A name is required</hc-error>
                </hc-form-field>
                <hc-form-field>
                    <hc-label>Okta ID (Email):</hc-label>
                    <input
                        hcInput
                        formControlName="okta_id"
                        placeholder="Enter user's okta ID"
                        class="user-okta-id-input"
                        [required]="true"
                    />
                    <hc-error>An Okta ID is required</hc-error>
                </hc-form-field>
                <hc-form-field>
                    <hc-label>Role:</hc-label>
                    <hc-select formControlName="role">
                        <option value="admin">Admin</option>
                        <option value="super-admin">Super Admin</option>
                    </hc-select>
                </hc-form-field>
            </form>
        </hc-modal-body>
        <hc-modal-footer>
            <button hc-button buttonStyle="link" (click)="dismiss()">Cancel</button>
            <button
                hc-button
                buttonStyle="primary"
                [disabled]="data.edit ? !adminUserControl.dirty : !adminUserControl.valid"
                (click)="data.edit ? editUser() : addUser()"
            >
                {{ data.edit ? 'Update' : 'Add' }}
            </button>
        </hc-modal-footer>
    </hc-modal>
</ng-template>
